// Functions
import { renderToolTip } from "../../../../../../config/functions";
// Components
import { Header, HeaderTitle } from "./styles";
import ProtocolPrescription from "./sections/protocolPrescription";

const Prescriptions = ({ prescriptions }) => {
  const renderHeader = () => {
    return (
      <Header>
        <HeaderTitle width="290px" padding="0 0 0 133px">
          ACTIVITY
        </HeaderTitle>
        <HeaderTitle width="190px">WEEK DAYS</HeaderTitle>
        <HeaderTitle width="140px">FUNCTIONS</HeaderTitle>
        <HeaderTitle width="46px" textAlign="center" data-for="toolTipTitleId" data-tip={`Difficulty Modulators`}>
          D.M.
        </HeaderTitle>
        <HeaderTitle width="46px" textAlign="center" data-for="toolTipTitleId" data-tip={`Adherence`}>
          AD.
        </HeaderTitle>
        <HeaderTitle width="46px" textAlign="center" data-for="toolTipTitleId" data-tip={`Competence`}>
          COM.
        </HeaderTitle>
        <HeaderTitle width="72px" textAlign="center">
          TIME
        </HeaderTitle>
        <HeaderTitle width="30px" textAlign="center" data-for="toolTipTitleId" data-tip={`Reports`}>
          REP.
        </HeaderTitle>
        {renderToolTip("toolTipTitleId")}
      </Header>
    );
  };

  const renderActivities = () => {
    return prescriptions.map((prescription) => {
      const protocolId = prescription.PROTOCOL_ID;
      return (
        <ProtocolPrescription
          key={protocolId}
          protocolId={protocolId}
          prescriptionDuration={prescription.PRESCRIPTION_DURATION}
          prescriptionDays={prescription.PRESCRIPTION_DAYS}
          dmValue={prescription.delta_dm}
          adherenceValue={prescription.recent_adherence}
          competenceValue={prescription.ppf}
          sessionsNumber={prescription.SESSIONS}
          status={prescription.STATUS}
        />
      );
    });
  };

  return (
    <>
      {renderHeader()}
      {renderActivities()}
    </>
  );
};

export default Prescriptions;
